import React from 'react';

import GenericTextImageLayout from '@lendi-jam/generic-text-image-layout';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import parse from 'html-react-parser';

import { GenericTextImageLayoutContent } from '#contentTypes/GenericTextImageLayout';

interface PrismicGenericTextImageLayoutProps {
  component: GenericTextImageLayoutContent;
}

const GenericPrismicTextImageLayout: React.FC<PrismicGenericTextImageLayoutProps> = ({ component }) => {
  const content = component.primary;
  const steps = component.items.map((item) => ({
    title: item.step_title.text,
    description: parse(item.step_description.html),
  }));

  return (
    <GenericTextImageLayout
      heading={content.heading.text}
      hideImageOnMobile={content.hide_image_mobile}
      image={content.image}
      primaryButtonLink={embedMarketingTrackingIntoURL(content.primary_button_link.url || '')}
      primaryButtonText={content.primary_button_text.text}
      secondaryButtonLink={embedMarketingTrackingIntoURL(content.secondary_button_link.url || '')}
      secondaryButtonText={content.secondary_button_text.text}
      steps={steps}
      variant={content.variant}
    />
  );
};

export default GenericPrismicTextImageLayout;
